import httpClient from "./httpClient";

const base = "/students";

export function listStudents(academicYear, classConfigurationId) {
  const params = { academicYear };
  if (classConfigurationId) {
    params.classConfigurationId = classConfigurationId;
  }
  return httpClient.get(base, { params }).then((res) => res.data.data);
}

export function getStudent(id) {
  return httpClient.get(`${base}/${id}`).then((res) => res.data.data);
}

export function createStudent(payload) {
  return httpClient.post(base, payload).then((res) => res.data.data);
}

export function updateStudent(id, payload) {
  return httpClient.put(`${base}/${id}`, payload).then((res) => res.data.data);
}

export function updateStudentStatus(id, payload) {
  return httpClient.put(`${base}/${id}/status`, payload).then((res) => res.data.data);
}

export function uploadStudentPhoto(id, file) {
  const formData = new FormData();
  formData.append("file", file);
  return httpClient
    .post(`${base}/${id}/photo`, formData, { headers: { "Content-Type": "multipart/form-data" } })
    .then((res) => res.data.data);
}

export function deleteStudent(id) {
  return httpClient.delete(`${base}/${id}`).then((res) => res.data);
}

export function migrateStudents(payload) {
  return httpClient.post(`${base}/migration/migrate`, payload).then((res) => res.data);
}

export function pushbackMigration(payload) {
  return httpClient.post(`${base}/migration/push-back`, payload).then((res) => res.data);
}
